<script lang="ts">
    import { api } from "../../../../api"
    import { login } from "../../../store"
    import { downloadFile } from "../../../utils"

    export let task: Task
    async function downloadTaskNotification() {
        api(
            "action",
            {
                method: "POST",
                useJwt: true,
                jwtToUse: $login.tokenString,
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            },
            {
                operation: "createTaskNotification",
                id: task.id,
            }
        )
            .then((response) => {
                const file = response.data
                downloadFile(file, "Einsatzmeldung.pdf")
            })
            .catch((e) => {
                console.error(e)
            })
    }
</script>

<ul>
    <li>
        <button on:click|stopPropagation|preventDefault="{downloadTaskNotification}">
            <span
                ><img
                    alt="icon"
                    src="../../../../../assets/icons/solar_download-minimalistic-outline.svg"
                /></span
            >
            <span>Einsatzmeldung</span>
        </button>
    </li>
</ul>

<style lang="less">
    span {
        white-space: wrap;
    }
    button {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        color: var(--text-100);
    }
</style>
